module.exports = __webpack_public_path__ + "img/Mirjam.cc26c010.jpg";